// ** Initial State
const initialState = {
  data: [],
  total: 1,
  params: {},
  allData: [],
  notifyDelete: null,
  notifyFailedDelete: null,
  newPatientData: null,
  selectedPatientData: null
}

const DataTablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA_PATIENT':
      return {
        ...state,
        allData: action.allData,        
        data: action.data,
        total: action.totalPages,
        params: action.params
      }   
    case 'RESET_DATA_PATIENT':
      return {
        ...state,
        allData: []
      }   
    case 'GET_SELECTED_DETAIL_PATIENT':      
      return {
        ...state,
        selectedPatientData: action.patientData
      } 
    case 'RESET_SELECTED_DETAIL_PATIENT':
      return {
        ...state,
        selectedPatientData: null
      }   
    default:
      return state
  }
}

export default DataTablesReducer
